import { AnalyticsEventDispatcher } from '../AnalyticsEventDispatcher'
import { EventDispatcherConfig } from '../types'

import {
  CustomEventDispatchers,
  CustomEventDispatcherOptions,
} from '../types/analytics-manifest'

export function createManifestDispatcher<C extends CustomEventDispatchers>(
  dispatcherConfig: EventDispatcherConfig,
  customEventsDispatcher?: (
    customEventDispatcherOptions: CustomEventDispatcherOptions,
  ) => C,
) {
  const eventDispatcher = new AnalyticsEventDispatcher(dispatcherConfig)
  return Object.assign(
    eventDispatcher,
    customEventsDispatcher?.({ dispatcher: eventDispatcher }),
  )
}
